import React, { useEffect, useState } from 'react';
import SelectComponent, { PropsValue } from 'react-select';
import './select.scss';
import { DropdownIndicator } from '@/assets/icons';
import { Controller, useFormContext } from 'react-hook-form';
import clsx from 'clsx';
import { SelectCloseCross } from '@/assets/icons';

export interface SelectOption {
    value: string | number;
    label: string;
}

interface Props {
    className?: string;
    wrapperClassName?: string;
    options: SelectOption[];
    onSearch?: (searchString: string) => void;
    isClearable?: boolean;
    isMulti?: boolean;
    placeholder?: string;
    name: string;
    isLoading?: boolean;
    onSelected?: (
        data: SelectOption | SelectOption[],
        onChange: (event: any[]) => void 
    ) => void;
    keepLastOption?: boolean;
}

export const Select: React.FC<Props> = ({
    className,
    wrapperClassName,
    name,
    onSearch,
    options = [],
    isMulti = false,
    isClearable = true,
    placeholder = 'Выберете город',
    isLoading,
    onSelected,
    keepLastOption = false,
}) => {

    const [isFocused, setFocused] = useState<boolean>()

    const { control, setValue } = useFormContext();

    const limitedOptions = options.slice(0, 3);

    const MultiValueRemove = (props: any) => {
        const selectedValues = props.selectProps.value || [];
        const count = Array.isArray(selectedValues) ? selectedValues.length : 0;
        const {
            className,
            innerProps: { id, onClick, onMouseDown, onTouchEnd, css: style, tabIndex, 'aria-label': ariaLabel },
        } = props;

        if (isMulti && keepLastOption && count <= 1) return null;

        return (
            <div
                id={id}
                onClick={onClick}
                onMouseDown={onMouseDown}
                onTouchEnd={onTouchEnd}
                style={style}
                tabIndex={tabIndex}
                aria-label={ariaLabel}
                className={className} // должен быть строкой
                role="button"
            >
                <SelectCloseCross />
            </div>
        );
    };

    return (
        <div className={clsx('react-select', wrapperClassName)}>
            <Controller
                control={control}
                name={name}
                render={({ field: { onChange, value, ref } }) => {
                    const handleChange = (val: SelectOption | SelectOption[]) => {
                        if (keepLastOption && isMulti && Array.isArray(val) && val.length === 0) {
                            return;
                        }

                        onChange(val);
                        onSelected?.(val, onChange);
                    };
                    return (
                        <SelectComponent
                            className={className}
                            menuPlacement="auto"
                            options={limitedOptions}
                            onChange={handleChange}
                            onInputChange={onSearch}
                            isClearable={isClearable}
                            isMulti={isMulti}
                            placeholder={placeholder}
                            classNamePrefix="react-select"
                            isLoading={isLoading}
                            isSearchable
                            value={value}
                            components={{
                                DropdownIndicator: () => <DropdownIndicator />,
                                IndicatorSeparator: () => null,
                                NoOptionsMessage: () => <div className={'select-empty'}>Ничего не найдено</div>,
                                MultiValueRemove: MultiValueRemove,
                            }}
                            ref={ref}
                            menuIsOpen={isFocused}
                            onBlur={() => setFocused(false)}
                            onFocus={() => setFocused(true)} />
                    );
                }}
            />
        </div>
    );
};
